import { useInViewport } from 'ahooks';
import { SlateValue2MustacheV2 } from 'components/TemplateEditor/mustacheUtils';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import useStatus from 'hooks/useStatus';
import { HTMLAttributes, useEffect, useRef, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { getSlateContent } from 'views/Aide/Scenario/PolicyForm';
import { translateTemplate } from 'views/Aide/Scenario/PolicyForm/TranslateTool';
import { getChunks } from 'views/Aide/Scenario/PolicyTable';
import { ChunkRender } from 'views/BootGuide/components/Reuse/ChunkRender';

export interface TranslateProps extends HTMLAttributes<HTMLDivElement> {
  value: string;
  lang?: General.Language;
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
}

function Translate(props: TranslateProps) {
  const systemLang = useSystemLanguageValue();

  const { value, lang = systemLang, platform, region } = props;

  const { t } = useTranslate();

  const [chunks, setChunks] = useState(() => getChunks({ content: '', translatedContent: '' }));

  const ref = useRef<HTMLDivElement>(null);

  const [visible] = useInViewport(ref);

  const { pending, error, done } = useStatus();

  const translatedParamsRef = useRef<{ value: string; lang: General.Language }>();

  useEffect(() => {
    if (
      !visible ||
      (value === translatedParamsRef.current?.value && lang === translatedParamsRef.current?.lang)
    ) {
      return;
    }

    done.pending();

    translateTemplate(getSlateContent(value), lang, [], undefined, { from: 'gpt4TranslateTool' })
      .then((result) => {
        done();

        setChunks(
          getChunks({
            content: `#mustache#${SlateValue2MustacheV2(result)}`,
            translatedContent: '',
          }),
        );

        translatedParamsRef.current = {
          value,
          lang,
        };
      })
      .catch(done.error);
  }, [value, lang, done, visible]);

  const content = pending ? (
    t('Entities.翻译中')
  ) : error ? (
    t('Entities.翻译失败')
  ) : (
    <ChunkRender chunks={chunks} platform={platform} region={region} />
  );

  return <div ref={ref}>{content}</div>;
}

export default Translate;
